import React from 'react';
import { Menu, Button, Dropdown } from 'antd';
import { Link, useLocation } from 'react-router-dom';
import { BulbOutlined, PhoneOutlined, MailOutlined, UserOutlined } from '@ant-design/icons';
import type { MenuProps } from 'antd';
import { useTheme } from '../../context/ThemeContext';
import './Nav.less';

const Nav: React.FC = () => {
  const location = useLocation();
  const currentPath = location.pathname;
  const { toggleTheme, theme } = useTheme();

  const menuItems: MenuProps['items'] = [
    {
      key: '/',
      label: (
        <Link to="/">首页</Link>
      ),
    },
    {
      key: '/academics',
      label: (
        <Dropdown
          menu={{
            items: [
              {
                key: '/academics',
                label: <Link to="/academics">教学科研</Link>,
              },
              {
                key: '/academics/departments',
                label: <Link to="/academics/departments">学院设置</Link>,
              },
              {
                key: '/academics/majors',
                label: <Link to="/academics/majors">专业设置</Link>,
              },
              {
                key: '/academics/research',
                label: <Link to="/academics/research">科研平台</Link>,
              },
            ],
          }}
        >
          <a onClick={(e) => e.preventDefault()}>教学科研</a>
        </Dropdown>
      ),
    },
    {
      key: '/admissions',
      label: (
        <Link to="/admissions">招生就业</Link>
      ),
    },
    {
      key: '/campus',
      label: (
        <Link to="/campus">校园生活</Link>
      ),
    },
    {
      key: '/about',
      label: (
        <Dropdown
          menu={{
            items: [
              {
                key: '/about',
                label: <Link to="/about">关于我们</Link>,
              },
              {
                key: '/about/introduction',
                label: <Link to="/about/introduction">学校简介</Link>,
              },
              {
                key: '/about/history',
                label: <Link to="/about/history">发展历程</Link>,
              },
              {
                key: '/about/contact',
                label: <Link to="/about/contact">联系我们</Link>,
              },
            ],
          }}
        >
          <a onClick={(e) => e.preventDefault()}>关于我们</a>
        </Dropdown>
      ),
    },
  ];

  const quickLinks = [
    { key: '1', icon: <PhoneOutlined />, text: '电话咨询' },
    { key: '2', icon: <MailOutlined />, text: '邮件联系' },
    { key: '3', icon: <UserOutlined />, text: '用户中心' },
  ];

  return (
    <nav className="nav-container">
      <div className="nav-content">
        <div className="nav-header">
          <div className="school-logo">小羊</div>
          <div className="school-name">羊小羊</div>
        </div>
        
        <Menu
          mode="horizontal"
          selectedKeys={[currentPath]}
          items={menuItems}
          className="nav-menu"
        />
        
        <div className="nav-right">
          <div className="quick-links">
            {quickLinks.map(item => (
              <Button key={item.key} type="text" icon={item.icon} className="quick-link-btn">
                {item.text}
              </Button>
            ))}
          </div>
          <Button
            type="primary"
            icon={<BulbOutlined />}
            onClick={toggleTheme}
            className="theme-toggle-btn"
            title={theme === 'light' ? '切换到暗色主题' : '切换到亮色主题'}
          >
            {theme === 'light' ? '暗色' : '亮色'}
          </Button>
        </div>
      </div>
    </nav>
  );
};

export default Nav;